// extracted by mini-css-extract-plugin
export default {"loader--fullscreen":"loader_loader--fullscreen__MMske"};